import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateStatus } from 'modules/settings/submodules/platformUsers/components/UpdateStatus/UpdateStatus';
import { Status } from 'shared/models/Status';
import { selectIsDealStatusUpdating } from 'modules/settings/submodules/clients/deals/components/UpdateStatusSelect/store/selectors';
import { setDealStatus } from 'modules/settings/submodules/clients/deals/components/UpdateStatusSelect/store/actions';

export interface IUpdateDealStatusSelectProps {
    id: string;
    status: Status;
    className?: string;
}

export const UpdateDealStatusSelect = (props: IUpdateDealStatusSelectProps) => {
    const { id, status, className } = props;
    const dispatch = useDispatch();
    const isLoading = useSelector(selectIsDealStatusUpdating);
    const handleStatusChange = useCallback((newValue: Status) => {
        dispatch(setDealStatus.init({
            id,
            status: newValue,
        }));
    }, [dispatch, id]);

    return (
        <UpdateStatus
            status={status}
            handleStatusChange={handleStatusChange}
            isLoading={isLoading}
            formControlClassName={className}
        />
    );
};
